import { ScrollArea } from '@/components/ui/scroll-area';
import { ExternalLink } from 'lucide-react';

const NewsSection = ({ title, news, icon, testId }) => {
  return (
    <div className="content-card" data-testid={testId}>
      <div className="card-header">
        <h2>{icon} {title}</h2>
      </div>
      <ScrollArea className="card-content">
        {news.length > 0 ? (
          <div className="news-list">
            {news.map((item, index) => (
              <div key={item.link || `${item.title}-${index}`} className="news-item" data-testid={`${testId}-item-${index}`}>
                <h3 className="news-title">{item.title}</h3>
                {item.summary && <p className="news-summary">{item.summary}</p>}
                {item.link && (
                  <a 
                    href={item.link} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="news-link"
                    data-testid={`${testId}-link-${index}`}
                  >
                    Read more <ExternalLink size={14} />
                  </a>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="no-data">No news available</p>
        )}
      </ScrollArea>
    </div>
  );
};

export default NewsSection;